import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import DownloadIcon from "@material-ui/icons/CloudDownload";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
//import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import FlightsTable from "./FlightsTable.jsx";
import SearchComponent from "./SearchPanel.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import FlightIcon from "@material-ui/icons/Flight";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";
import { appHelpers } from "../../_helpers";
import Modal from "../../utils/Modal";
import PassengersTable from "./PassengersTable.jsx";
import moment from "moment/moment";

// import FloatingButton from "../../utils/FloatingButton";

const end_time = new Date();
let start_time = new Date();
start_time.setDate(end_time.getDate() - 7);
// const customModalStyle = {
//     width: '75%',
//     maxWidth: 'none',
//     overflow: 'scroll',
//     msOverflowY: 'scroll !important',
//     overflowY: 'visible !important'
// };
class AirlinesPassenger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: "",
            open: false,
            selectedMonthValue: "",
            selectedAirlineValue: "",
            airlines: [],
            flightNumbers: [],
            flights: [],
            totalFlightCounts: 0,
            totalPassengerCounts: 0,
            AirlineId: '-1',
            FlightNumber: '-1',
            StartDate: start_time,
            EndDate: end_time,
            activeFlight: false,
            flightPassengers: [],
            flightPassengerCount: 0,
            requestingFlights: true,
            requestingPassengers: true,
            currentPage: 1,
            pageSize: 10,
            passengerModal: false,
            passengerPageSize: 5,
            passengerCurrentPage: 1,
            allLocations: [],
            AirportCode: "-1",
            addedPassengers: [],
            TicketNumber: "",
            PassengerType: "",
            TicketClass: "",
            AdultPassengers: "",
            ChildPassengers: "",
            InfantPassengers: "",
            showPassengerForm: false,
            createPassengersEntityTypeId: null,
            Airline: null,
            singleFlight: "",

        };
    }
    handleDateChange = (date, target) => {
        // console.log({date})
        this.setState({ [target]: date });
    };
    handleAirlineChange = event => {
        this.setState({ selectedAirlineValue: event.target.value });
    };

    handleSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === 'AirlineId') {
            this.setState({ flightNumbers: [], FlightNumber: "-1" });
            this.fetchAirlineFlightNumbers(event.target.value);
        }
    };


    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
            this.setState({[name.name]: "-1"} )
        }
        if (name.name === "AirlineId") {
            this.setState({ flightNumbers: [], FlightNumber: "-1" });
            this.fetchAirlineFlightNumbers(value.value);
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true,
        });
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    componentDidMount() {
        let { airlines, user, airports, entityTypes } = store.getState();
        const { startDate, endDate, pageSize } = this.state;

        const { dispatch } = this.props;
        if (airlines) {
            this.setState({ airlines: airlines })
        } else {
            dispatch(commonActions.getAllAirlines());
        }

        if (airports) {
            this.setState({ allLocations: airports })
        } else {
            dispatch(commonActions.getAllAirports())
        }

        if (user.AppRole === appConstants.ROLES.VGG_ADMIN) {
            if (!entityTypes) {
                dispatch(commonActions.getEntityTypes())
            } else {
                this.setEntityTypes(entityTypes)
            }
        }

        /*Check Type of User*/
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline });
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirlineId: user.AirlineId,
                From: 1,
                Size: pageSize,
            };
            this.searchFlights(1, payload);
        }
        else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportCode: userLocation });
            this.fetchAirlineFlightNumbers(user.AirlineId);
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirportCode: user.AirportCode,
                From: 1,
                Size: pageSize,
            };
            this.searchFlights(1, payload);
        } else if (user.Location) {  //Check if location is mapped to user. That means its an outstation user
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportCode: userLocation });
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirportCode: user.AirportCode,
                From: 1,
                Size: pageSize,
            };
            this.searchFlights(1, payload);
        }
        else {
            this.searchFlights(1);
        }
    }
    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports, entityTypes, user } = nextProps;
        if (airlines) {
            let modifiedAirline = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlines: modifiedAirline });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({ Name: "All Airport", AirportCode: "-1" });
            this.setState({ allLocations: modifiedAirport })
        }

        if (user.AppRole === appConstants.ROLES.VGG_ADMIN && entityTypes) {
            this.setEntityTypes(entityTypes)
        }

    };

    setEntityTypes = (entityTypes) => {
        let createPassengersEntityTypeId;

        entityTypes.forEach(entity => {
            if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_PASSENGERS) {
                createPassengersEntityTypeId = entity.EntityTypeId;
            }

        });
        this.setState({ createPassengersEntityTypeId: createPassengersEntityTypeId })

    }

    handlePassengerModal = (activeFlight) => {
        const { passengerModal } = this.state;
        console.log(passengerModal, "mode");
        console.log(activeFlight, "active");
        if (activeFlight) {
            this.setState({ 
                activeFlight, 
                passengerModal: !passengerModal,
                singleFlight: activeFlight
            });
            this.fetchFlightPassengers(activeFlight);
        } else {
            this.setState({ passengerModal: !passengerModal });
        }
    };

    handleClosePassengerModal = () => {
        this.setState({
            passengerModal: false,
            activeFlight: false,
            showPassengerForm: false,
            addedPassengers: []
        });

    };

    fetchAirlineFlightNumbers = (airlineId) => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let modifiedFlights = [...response.Results];
                    modifiedFlights.unshift({ FlightNumber: "All Flights" });
                    this.setState({ flightNumbers: modifiedFlights });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            });
    };
    searchFlights = (pageNumber = 1, payload) => {
        const { AirlineId, FlightNumber, pageSize, StartDate, EndDate, AirportCode } = this.state;
        const { dispatch } = this.props;
        if (!payload) {
            payload = {
                startDate: moment(StartDate).format('YYYY-MM-DD') + "T00:00:00",
                endDate: moment(EndDate).format('YYYY-MM-DD') + "T23:59:59",
                From: pageNumber,
                Size: pageSize
            };
            if (FlightNumber !== "-1" && FlightNumber !== "All Flights") {
                payload.flightNumber = FlightNumber.value;
            }
            if (AirlineId !== '-1') {
                payload.AirlineId = AirlineId.value;
            }
            if (AirportCode !== '-1') {
                payload.AirportCode = AirportCode.value;
            }
        };

        dispatch(alertActions.startRequest());
        commonService.getFlights(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber, requestingFlights: false,
                        flights: response.ResponseType.Manifests,
                        totalFlightCounts: response.ResponseType.Count,
                        totalPassengerCounts: response.ResponseType.TotalPassengers
                    });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingFlights: false });
                }
            });
    };
    fetchFlightPassengers = (activeFlight, pageNumber = 1) => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        this.setState({ flightPassengers: [], activeFlight: activeFlight, flightPassengerCount: 0, requestingPassengers: true });
        let payload = { From: pageNumber, Size: 5, manifestId: activeFlight.Id };

        commonService.getFlightPassengers(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.IsSuccess) {
                        this.setState({ passengerCurrentPage: pageNumber, requestingPassengers: false, flightPassengers: response.ResponseType.Passengers, flightPassengerCount: response.ResponseType.Count });
                    } else {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingPassengers: false });
                }
            });
    };

    fetchMoreFlightPassengers = (pageNumber) => {
        this.fetchFlightPassengers(this.state.activeFlight, pageNumber);
    };
    downloadManifests = (type) => {
        const { dispatch } = this.props;
        const { FlightNumber, AirlineId, AirportCode, StartDate, EndDate } = this.state;
        const payload = {
            StartDate: moment(StartDate).format('YYYY-MM-DD') + "T00:00:00",
            EndDate: moment(EndDate).format('YYYY-MM-DD') + "T23:59:59",
            Type: type
        };
        if (FlightNumber !== "-1") {
            payload.flightNumber = FlightNumber.value;
        }
        if (AirlineId !== '-1') {
            payload.AirlineId = AirlineId.value;
        }
        if (AirportCode !== '-1') {
            payload.AirportCode = AirportCode.value;
        }
        dispatch(alertActions.startRequest());
        commonService.downloadFlights(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.ErrorMessageList.length > 0) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                        this.setState({ pageRequesting: false });
                    } else {
                        if (response.DownloadUrl !== null) {
                            appHelpers.downloadFile(response.ResponseType.DownloadUrl, "Manifest Report");
                        } else {
                            dispatch(alertActions.error(response.Message));
                        }
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (response.ErrorMessageList) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                    }
                    else if (typeof response === 'string') {
                        dispatch(alertActions.error(response));
                    } else {
                        dispatch(alertActions.error("Something went wrong."));
                    }
                    this.setState({ pageRequesting: false });
                }
            });
    };
    downloadManifestPassenger = (type) => {
        const { dispatch } = this.props;
        const { activeFlight } = this.state;
        const payload = {
            "ManifestId": activeFlight.Id,
            "Type": type
        };
        dispatch(alertActions.startRequest());
        commonService.downloadFlightPassengers(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.ErrorMessageList.length > 0) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                        this.setState({ pageRequesting: false });
                    } else {
                        if (response.DownloadUrl !== null) {
                            appHelpers.downloadFile(response.ResponseType.DownloadUrl, "Flight Passenger Report");
                        } else {
                            dispatch(alertActions.error(response.Message));
                        }
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (response.ErrorMessageList) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                    }
                    else if (typeof response === 'string') {
                        dispatch(alertActions.error(response));
                    } else {
                        dispatch(alertActions.error("Something went wrong."));
                    }
                    this.setState({ pageRequesting: false });
                }
            });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    addPassenger = () => {
        const { dispatch } = this.props;
        let { TicketNumber, TicketClass, PassengerType, addedPassengers, activeFlight } = this.state;
        if (TicketNumber === "" || TicketClass === "" || PassengerType === "") {
            dispatch(alertActions.error("Please all fields are required"));
            return;
        }
        const Id_ = new Date().getTime();
        addedPassengers = [...addedPassengers, { Id_, TicketNumber, TicketClass, PassengerType, "ManifestId": activeFlight.Id }];
        this.setState({ addedPassengers, TicketNumber: "", TicketClass: "", PassengerType: "" });
    };

    //generate passengers based on  a passengers & additional billable passengers
    generatePassengers = () => {
        let { addedPassengers, activeFlight, AdultPassengers, ChildPassengers, InfantPassengers } = this.state;

        // add adult passengers
        if (AdultPassengers !== "") {
            for (let i = 0; i < AdultPassengers; i++) {
                let Id_ = `${new Date().getTime()}${appHelpers.getRandomNumber(1000)}`;
                let passengerRecord = { Id_, TicketNumber: `TICKETNUMBER-${activeFlight.Id}`, TicketClass: appHelpers.generateRandomCharacters(), PassengerType: "A", "ManifestId": activeFlight.Id }
                addedPassengers = [...addedPassengers, passengerRecord]
            }
        }

        // add child passengers
        if (ChildPassengers !== "") {
            for (let i = 0; i < ChildPassengers; i++) {
                let Id_ = `${new Date().getTime()}${appHelpers.getRandomNumber(1000)}`;
                let passengerRecord = { Id_, TicketNumber: `TICKETNUMBER-${activeFlight.Id}`, TicketClass: appHelpers.generateRandomCharacters(), PassengerType: "C", "ManifestId": activeFlight.Id }
                addedPassengers = [...addedPassengers, passengerRecord]
            }
        }

        // add infant passengers
        if (InfantPassengers !== "") {
            for (let i = 0; i < InfantPassengers; i++) {
                let Id_ = `${new Date().getTime()}${appHelpers.getRandomNumber(1000)}`;
                let passengerRecord = { Id_, TicketNumber: `TICKETNUMBER-${activeFlight.Id}`, TicketClass: appHelpers.generateRandomCharacters(), PassengerType: "I", "ManifestId": activeFlight.Id }
                addedPassengers = [...addedPassengers, passengerRecord]
            }
        }

        // make each generated ticket number unique using time and its array index
        addedPassengers.map((item, i) => {
            if (item["TicketNumber"].includes("TICKETNUMBER")) {
                item.TicketNumber = `TICKETNUMBER${i + 1}${new Date().getTime()}-${activeFlight.Id}`;
            }
            return { ...item };
        });
        
        this.setState({ addedPassengers, AdultPassengers: "", ChildPassengers: "", InfantPassengers: "" });
    }

    removePassenger = (id) => {
        let filterPassengers = this.state.addedPassengers.filter(item => item.Id_ !== id);
        this.setState({ addedPassengers: filterPassengers });
    }

    handleShowPassengerForm = () => {
        this.setState({ showPassengerForm: !this.state.showPassengerForm })
    }

//     getPassengerRecord = (item) => {
// let view = {
//     Airline: item.Airline,

// }
// handleItem = (item) => {
//     this.setState({
//         Airline: item.Airline,
//         FlightNumber: item.FlightNo,
//         Departure: item.DestinationAirportName
//     });
//   };
  
    addPassengers = (item) => {
        const { dispatch, user } = this.props;
        const { addedPassengers, createPassengersEntityTypeId, singleFlight } = this.state;
        if (addedPassengers.length < 1) {
            dispatch(alertActions.error("Please enter records to be saved"));
            return;
        }

        let payload = addedPassengers.filter((item) => delete item.Id_);

        const {Airline,
        FlightNo,
        DepartureAirport} = singleFlight;
        let payloadTemplate = {
            flights: [{Airline,
                FlightNo,
                DepartureAirport}],
            passengers: payload,
            // Airline: item.Airline,
            // FlightNumber: item.FlightNo,
            // Departure: item.DestinationAirportName
        }

        let makerCheckerPayload = {
            AppId: appConstants.MAKER_CHECKER_APP_ID,
            Payload: JSON.stringify(payload),
            PayloadViewTemplate: JSON.stringify(payloadTemplate),
            URL: `${appConstants.PAS_URL}/api/Manifest/SavePassengerBatch`,
            EntityTypeId: createPassengersEntityTypeId,
            CreatedBy: user.userName
        };
        dispatch(alertActions.startRequest());
        commonService.createMakerChecker(makerCheckerPayload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify("Passengers sent for approval"));
                    this.handleClosePassengerModal();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            });
    };

    render() {
        const { classes, user, requesting } = this.props;
        const { currentPage, pageSize, flightPassengers, requestingFlights,
            totalPassengerCounts, flightPassengerCount, flights, totalFlightCounts,
            airlines, name, activeFlight, AirlineId, FlightNumber, StartDate,
            EndDate, flightNumbers, passengerModal, passengerPageSize,
            passengerCurrentPage, allLocations, AirportCode, addedPassengers,
            TicketClass, TicketNumber, PassengerType, showPassengerForm, AdultPassengers,
            ChildPassengers, InfantPassengers
        } = this.state;
        /*return          (
            <FloatingButton/>
        )*/
        if (requestingFlights)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <Modal
                    title={"false"}
                    content={
                        <PassengersTable
                            activeFlight={activeFlight}
                            flightPassengerCount={flightPassengerCount}
                            flightPassengers={flightPassengers}
                            pageSize={passengerPageSize}
                            currentPage={passengerCurrentPage}
                            fetchPassengers={this.fetchMoreFlightPassengers}
                            handleChange={this.handleChange}
                            addedPassengers={addedPassengers}
                            addPassenger={this.addPassenger}
                            removePassenger={this.removePassenger}
                            TicketClass={TicketClass}
                            PassengerType={PassengerType}
                            TicketNumber={TicketNumber}
                            showPassengerForm={showPassengerForm}
                            handleShowPassengerForm={this.handleShowPassengerForm}
                            userRole={user.AppRole}
                            generatePassengers={this.generatePassengers}
                            AdultPassengers={AdultPassengers}
                            ChildPassengers={ChildPassengers}
                            InfantPassengers={InfantPassengers}
                        />
                    }
                    modalStatus={passengerModal}
                    isAddPassengerModal={true}
                    showPassengerForm={showPassengerForm}
                    handleClose={this.handleClosePassengerModal}
                    modalActionLabel={(showPassengerForm) ?
                        <Button onClick={() => this.addPassengers()} color={'primary'} autoFocus>
                            Save
                        </Button>
                        :
                        <div>
                            <Button onClick={() => this.downloadManifestPassenger("pdf")} type="button" color="info" >
                                <DownloadIcon />
                                Download PDF
                        </Button>
                            <Button onClick={() => this.downloadManifestPassenger("excel")} type="button" color="primary" >
                                <DownloadIcon />
                                Download EXCEL
                        </Button>
                        </div>}
                />

                <GridContainer>
                    <SearchComponent
                        user={this.props.user}
                        airlines={airlines}
                        flightNumbers={flightNumbers}
                        airline={name}
                        selectChange={(e, name) => this.handleReactSelectChange(e, name)}
                        AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                        FlightNumber={FlightNumber.value}
                        StartDate={StartDate}
                        EndDate={EndDate}
                        onSearch={this.searchFlights}
                        handleDateChange={this.handleDateChange}
                        allLocations={allLocations}
                        AirportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? AirportCode : AirportCode.value}
                    />
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <Card>
                            <CardHeader color="success" stats icon>
                                <CardIcon color="success">
                                    <Passenger />
                                </CardIcon>
                                <p className={classes.cardCategory}>
                                    Total&nbsp;
                                  {totalPassengerCounts === 1 && 'Passenger'}
                                    {totalPassengerCounts !== 1 && 'Passengers'}
                                </p>
                                <h3 className={classes.cardTitle}>
                                    {appHelpers.numberWithCommasOnly(totalPassengerCounts)}
                                </h3>
                            </CardHeader>
                            <CardFooter chart />
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                        <Card>
                            <CardHeader color="info" stats icon>
                                <CardIcon color="info">
                                    <FlightIcon />
                                </CardIcon>
                                <p className={classes.cardCategory}>
                                    Total&nbsp;
                                  {totalFlightCounts === 1 && 'Flight'}
                                    {totalFlightCounts !== 1 && 'Flights'}
                                </p>
                                <h3 className={classes.cardTitle}>
                                    {appHelpers.numberWithCommasOnly(totalFlightCounts)}
                                </h3>
                            </CardHeader>
                            <CardFooter chart>
                                {/* <div className={classes.stats}>
                  <AccessTime /> updated 4 minutes ago
                </div> */}
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="success">
                                <h4 className={classes.cardTitleWhite}>
                                    Passenger Information
                              </h4>
                                <p className={classes.cardCategoryWhite}>
                                    {`${totalFlightCounts}`} flights matched search criteria
                              </p>
                            </CardHeader>
                            <CardBody>
                                {
                                    totalFlightCounts !== 0
                                    &&
                                    <FlightsTable classes={classes} currentPage={currentPage} pageSize={pageSize} fetchFlights={this.searchFlights}
                                        flights={flights} totalFlightCounts={totalFlightCounts}
                                        handleModal={this.handlePassengerModal}
                                    />
                                }
                                {
                                    totalFlightCounts === 0
                                    &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <EmptyRecord message={'No flight record'} />
                                        </GridItem>
                                    </GridContainer>
                                }
                            </CardBody>
                            {
                                totalFlightCounts !== 0 &&
                                <CardFooter chart>
                                    <div>
                                        <Button type="button" color="info" onClick={() => this.downloadManifests('pdf')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download PDF
                                      </Button>
                                        <Button type="button" color="primary" onClick={() => this.downloadManifests('excel')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download EXCEL
                                        </Button>
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { modal, alert, airlines, requesting, progress, user, airports, entityTypes } = state;
    return {
        modal,
        user,
        alert,
        airlines,
        progress,
        requesting,
        airports,
        entityTypes
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(AirlinesPassenger)));




// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/Index.jsx